import React, { useState, useEffect } from "react"
import { PieChart } from "@mui/x-charts/PieChart"

export default function VAPieChart({ chartData }) {
  return (
    <PieChart
      series={[
        {
          data: chartData,
          highlightScope: { fade: "global", highlight: "item" },
          faded: { innerRadius: 30, additionalRadius: -10, color: "gray" },

          innerRadius: 30,
          outerRadius: 70,
          paddingAngle: 5,
          cornerRadius: 5,
          startAngle: -45,
          // endAngle: 225,
          cx: 150,
          // cy: 150,
        },
      ]}
    />
  )
}
